// extracted by mini-css-extract-plugin
export default {"loading":"Loading_loading__Bfb1r","progress":"Loading_progress__X7rGF"};